import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PromoPopup.css';

const PromoPopup = ({ onSelectBuddy }) => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!visible) {
      const timer = setTimeout(() => setVisible(true), 15000);
      return () => clearTimeout(timer);
    }
  }, [visible]);

  const handleClose = () => {
    setVisible(false);
  };

  const handleCTA = () => {
    setVisible(false);
    if (onSelectBuddy) {
      onSelectBuddy();
    } else {
      navigate('/login');
    }
  };

  if (!visible) return null;

  return (
    <div className="promo-overlay" onClick={handleClose}>
      <div className="promo-popup" onClick={(e) => e.stopPropagation()}>
        <div className="promo-accent"></div>
        <button className="promo-close" onClick={handleClose}>×</button>
        <div className="promo-body">
          <div className="promo-ribbon"><span className="promo-ribbon-dot"></span> Oferta de lanzamiento</div>
          <img src={process.env.PUBLIC_URL + '/paquita.jpg'} alt="Doña Paquita" className="promo-avatar" />
          <h2 className="promo-title">Empieza hoy<br />con Paquita</h2>
          <p className="promo-subtitle">Compañía, voz y ayuda diaria para tu mayor.<br />Sin compromiso — cancela cuando quieras.</p>
          <div className="promo-price-block">
            <div className="promo-price-old">99€/mes</div>
            <div className="promo-price-new">9,90€ <small>/mes</small></div>
            <div className="promo-price-period">hasta el 31 de diciembre de 2026</div>
          </div>
          <div className="promo-features">
            <span className="promo-feature"><span className="promo-feat-icon">💬</span> Chat 24/7</span>
            <span className="promo-feature"><span className="promo-feat-icon">🎤</span> Voz</span>
            <span className="promo-feature"><span className="promo-feat-icon">📺</span> Tareas IA</span>
            <span className="promo-feature"><span className="promo-feat-icon">🛡️</span> Centinelas</span>
          </div>
          <button className="promo-cta" onClick={handleCTA}>Empezar ahora →</button>
          <div className="promo-trust">
            <span>🔒 Pago seguro con Stripe</span>
            <span>↩️ Cancela en cualquier momento</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoPopup;
